export default __webpack_public_path__ + "static/media/it-gif2.676fa298.gif";